import { css } from "styled-components";

export const actionBarStyle = css`
    &.aevi-action-bar {
        padding: 20px 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-evenly;
        gap: 10px;

        &.right {
            justify-content: right;
        }

        &.left {
            justify-content: left;
        }

        &.column {
            flex-direction: column;
            padding: 0;
        }
    }
`;
